export interface RGB {
  r: number;
  g: number;
  b: number;
}

export const hexToRgb = (hexColor: string): RGB => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hexColor = hexColor.replace(shorthandRegex, (m, r, g, b) => {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : {
        r: parseInt("0", 16),
        g: parseInt("0", 16),
        b: parseInt("0", 16)
      };
};

export const hexToRGBA = (hex: string, opacity: number) => {
  // ensure opacity within bounds
  if (opacity > 1) {
    opacity = 1;
  }
  if (opacity < 0) {
    opacity = 0;
  }
  // remove the hash
  hex = hex.charAt(0) === "#" ? hex.substr(1) : hex;
  if (hex.length === 3) {
    // each single char of a hex 3 is the equivalent of a double char in hex 6
    let rr = hex.substring(0, 1);
    let gg = hex.substring(1, 2);
    let bb = hex.substring(2, 3);
    hex = `${rr}${rr}${gg}${gg}${bb}${bb}`;
  }
  //get the r, g, b values converted from hex
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // build the rgba value with r, g, b, and a where a = opacity
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
